import { cn } from "@/libraries/cn";
import CircleIcon from "@mui/icons-material/Circle";
import IconButton from "@mui/material/IconButton";
import type { IconButtonProps } from "@mui/material/IconButton";

interface PhotoActionProps extends IconButtonProps {}

const PhotoAction: React.FC<PhotoActionProps> = ({
	color = "primary",
	size = "large",
	className,
	...props
}) => {
	return (
		<IconButton
			color={color}
			size={size}
			className={cn("!border-2 !border-white !border-solid !p-1", className)}
			{...props}
		>
			<CircleIcon className="!text-white !w-14 !h-14" />
		</IconButton>
	);
};

export default PhotoAction;
